<template>
	<div v-if="false" id="cart-total">
		<table class="cart_totals">
			<tr v-if="order.DiscountTotal">
				<th class="flex_start">
					<span class="pr-1">Discounts</span>
				</th>
				<td>
					<i class="material-icons">remove</i>
					<currency :fixed="true" :value="order.DiscountTotal" />
				</td>
			</tr>
			<tr>
				<th class="flex_start">Subtotal</th>
				<td>
					<currency :fixed="true" :value="order.SubTotal" />
				</td>
			</tr>
			<tr>
				<th class="flex_start">
					<span class="tooltip" style="margin-right: 5px;">
						<span class="pr-1">Taxes & Fees</span>
						<i class="material-icons">info</i>
						<div class="tooltip_popup">
							<section
								class="tooltip_details"
								v-if="order.OrderFeeClientLocations.length == 1"
							>
								<table class="order_fees">
									<tr>
										<th class="-text-blue">
											<h3 class="mt-0 mb-0">Taxes & Fees</h3>
										</th>
										<td></td>
									</tr>
									<tr
										v-for="(fee, i) in order.OrderFees"
										:key="'order-fees-' + i"
										v-show="fee.Amount"
									>
										<td align="left">{{ fee.FeeName }}</td>
										<td align="right">
											<currency :fixed="true" :value="fee.Amount" />
										</td>
									</tr>
								</table>
							</section>
							<section class="tooltip_details" v-else>
								<h3 class="mt-0 mb-0 " style="padding-left:10px;">
									Taxes & Fees
								</h3>
								<table
									class="order_fees"
									v-for="(location, i) in order.OrderFeeClientLocations"
									:key="'order-fee-location-' + i"
									v-show="location.OrderFees.length"
								>
									<tr>
										<td>
											<h3 class="mt-0 mb-0" style="position:relative;top:3px;">
												{{ location.LocationName }}
											</h3>
										</td>
									</tr>

									<tr
										v-for="(fee, i) in location.OrderFees"
										:key="'order-fees-' + i"
										v-show="fee.Amount"
									>
										<td align="left" style="padding-left:5px;">
											{{ fee.FeeName }}
										</td>
										<td align="right">
											<currency :fixed="true" :value="fee.Amount" />
										</td>
									</tr>
								</table>
							</section>
						</div>
					</span>
				</th>
				<td>
					<i class="material-icons">add</i>
					<currency :fixed="true" :value="order.TaxTotal" />
				</td>
			</tr>
			<tr v-if="!order.Credits">
				<th>Credits</th>
				<td>
					<i class="material-icons">remove</i>
					<currency :fixed="true" :value="order.Credits" />
				</td>
			</tr>
			<tr class="total">
				<th>Total</th>
				<td>
					<currency :fixed="true" :value="order.Balance" />
				</td>
			</tr>
		</table>

		<table class="cart_totals deposit" v-if="order.DepositEnabled">
			<tr class="total">
				<th v-if="client.DepositPercent == 0">Due now</th>
				<th v-else>{{ Math.round(client.DepositPercent) }}% deposit due now</th>
				<td>
					<currency :fixed="true" :value="order.Deposits" />
				</td>
			</tr>
		</table>

		<pre>order.Deposits = ${{ order.Deposits }}</pre>
	</div>
	<div v-else id="cart-total">
		<div class="cart-line-item " v-if="order.DiscountTotal">
			<span class="item-title">Discounts</span
			><span class="item-total"
				>-<currency :fixed="true" :value="order.DiscountTotal"
			/></span>
		</div>
		<div class="cart-line-item">
			<div class="item-title">Subtotal</div>
			<div class="item-total">
				<currency :fixed="true" :value="order.SubTotal" />
			</div>
		</div>
		<div class="cart-line-item" v-if="showFeeBreakdown">
			<div class="item-title total-tooltip">
				<span style="display: flex; align-items:center;">
					Taxes & Fees
					<!-- info icon -->
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="16"
						height="16"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="1.25"
						stroke-linecap="round"
						stroke-linejoin="round"
						style="padding-left: 10px;"
					>
						<circle cx="12" cy="12" r="10"></circle>
						<line x1="12" y1="16" x2="12" y2="12"></line>
						<line x1="12" y1="8" x2="12.01" y2="8"></line>
					</svg>
				</span>
				<div class="total-tooltip-popup">
					<!-- single location fees -->
					<section v-if="order.OrderFeeClientLocations.length == 1">
						<span class="tooltip-header text_size-large text_style-bold"
							>Taxes & Fees</span
						>
						<div
							class="tooltip-line-item text_size-small"
							v-for="(fee, i) in order.OrderFees"
							:key="'order-fees-' + i"
							v-show="fee.Amount"
						>
							<span>{{ fee.FeeName }}</span>
							<span><currency :fixed="true" :value="fee.Amount"/></span>
						</div>
					</section>
					<!-- multiple location fees -->
					<section v-else>
						<span class="tooltip-header text_size-large text_style-bold"
							>Taxes & Fees</span
						>
						<div
							class="text_size-medium"
							v-for="(location, i) in order.OrderFeeClientLocations"
							:key="'order-fee-location-' + i"
							v-show="location.OrderFees.length"
						>
							<span>{{ location.LocationName }}</span>
							<div
								class="tooltip-line-item text_size-small"
								v-for="(fee, i) in location.OrderFees"
								:key="'order-fees-' + i"
								v-show="fee.Amount"
							>
								<span>{{ fee.FeeName }}</span
								><span>
									<currency :fixed="true" :value="fee.Amount" />
								</span>
							</div>
						</div>
					</section>
				</div>
			</div>
			<div class="item-total">
				+<currency :fixed="true" :value="order.TaxTotal" />
			</div>
		</div>
		<div class="cart-line-item" v-else>
			<div class="item-title">
				<span style="display: flex; align-items:center;">
					Taxes & Fees
				</span>
			</div>
			<div class="item-total">
				+<currency :fixed="true" :value="order.TaxTotal" />
			</div>
		</div>
		<div v-if="order.Credits" class="cart-line-item">
			<div class="item-title">Credits</div>
			<div class="item-total">
				-<currency :fixed="true" :value="order.Credits" />
			</div>
		</div>
		<div
			class="cart-line-item"
			:class="order.DepositEnabled ? '' : 'text_style-bold'"
		>
			<div class="item-title">Total</div>
			<div class="item-total">
				<currency :fixed="true" :value="order.Balance" />
			</div>
		</div>
		<div
			v-if="order.DepositEnabled"
			class="cart-line-item text_style-bold"
			style="margin-top: 13px;"
		>
			<div v-if="client.DepositPercent == 0" class="item-title">Due now</div>
			<div v-else class="item-title">
				{{ Math.round(client.DepositPercent) }}% deposit due now
			</div>
			<div class="item-total">
				<currency :fixed="true" :value="order.Deposits" />
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex';

	export default {
		name: 'CartTotals',
		computed: {
			...mapState(['order', 'client']),
			showFeeBreakdown() {
				return !this.client.HideFeeBreakdown;
			},
		},
	};
</script>

<style lang="scss">
	#cart-total {
		padding: 0 var(--outer-padding);
		display: grid;
		grid-gap: 7px;
	}

	.cart-line-item {
		display: flex;
		justify-content: space-between;
		font-size: 15px;
		white-space: nowrap;
	}

	.total-tooltip {
		position: relative;
		cursor: pointer;

		.total-tooltip-popup {
			user-select: none;
			position: absolute;
			left: 10%;
			bottom: 150%;
			visibility: hidden;
			opacity: 0;
			background: #fff;
			padding: 12px;
			border-radius: 5px;
			box-shadow: 0px 0px 16px -1px #00000093;
			transition: all linear 150ms;

			&::before {
				content: '';
				position: absolute;
				width: 0;
				height: 0;
				top: 100%;
				left: 5%; // offset should move with padding of parent
				border: 0.75rem solid transparent;
				border-bottom: none;

				// looks
				border-top-color: #fff;
			}
		}

		&:hover {
			.total-tooltip-popup {
				visibility: visible;
				opacity: 1;
				transition: all linear 100ms;
			}
		}
	}

	.tooltip-line-item {
		display: flex;
		justify-content: space-between;
		padding: 0;
		> span:first-child {
			min-width: 100px;
			padding-left: 6px;
			padding-right: 20px;
		}
		> span {
			margin: 5px 0;
		}
	}

	table.deposit {
		white-space: nowrap;
		padding: 10px 0px;
		margin: 10px 0px;
		// border-top: 1px solid #D6DCE6;
	}
</style>
